import type { PartialMessages } from "../messages";

export const zhCN: PartialMessages = {
  "status.syncing": "已同步", "status.connecting": "连接中", "status.full": "已满", "status.closed": "已断开",
  "toast.connecting": "连接中…", "toast.reconnecting": "连接已断开，正在重连…",
  "toast.retrying": "稍后会自动重试。", "toast.busy": "当前比较拥挤",
  "notice.mapChanged": "{name} 切换了地图",
  "hint.place": "点击放置，按住拖动可确定朝向（Esc 取消）",
  "kind.objective": "目标", "kind.rally": "集合", "kind.enemy": "敌人", "kind.loot": "战利品",
  "kind.extract": "撤离", "kind.danger": "危险", "kind.self": "我", "kind.ping": "这里！",
  "hint.objective": "要去哪里", "hint.rally": "集合地点",
  "hint.enemy": "朝你看到的方向放置", "hint.loot": "稀有容器、尸体",
  "hint.extract": "打算走的撤离点", "hint.danger": "地雷、狙击手、开阔地",
  "hint.self": "你的当前位置。重新放置会覆盖之前的",
  "hint.ping": "25 秒后自动消失的临时标记",
  "tool.clearMine": "清除我的", "tool.clearMineHint": "清除你放置的所有标记",
  "sidebar.map": "地图（对所有人生效）", "sidebar.styleSvg": "手绘", "sidebar.styleTile": "卫星图",
  "sidebar.floors": "楼层（只改变你的视图）", "sidebar.groundFloor": "地面层",
  "sidebar.floorNote": "其他楼层的标记会淡化显示。",
  "sidebar.members": "{count} 人", "sidebar.you": "你", "sidebar.guest": "访客",
  "sidebar.clearAll": "清除所有标记", "sidebar.openWindow": "在单独窗口打开（仅自己）",
  "sidebar.invite": "邀请他人", "sidebar.help": "使用说明", "sidebar.feedback": "发送反馈",
  "sidebar.mapData": "地图数据", "sidebar.license": "许可协议", "sidebar.licenseNote": "仅限非商业使用",
  "sidebar.room": "房间",
  "pin.facing": "朝向", "pin.floor": "楼层", "pin.map": "地图", "pin.noFacing": "无朝向",
  "pin.facingValue": "{compass}（{degrees}°）",
  "pin.notePlaceholder": "写点备注（例如：三楼窗户）",
  "pin.removeMine": "删除这个标记", "pin.removeOther": "删除他人的标记", "pin.close": "关闭",
  "compass.n": "北", "compass.ne": "东北", "compass.e": "东", "compass.se": "东南",
  "compass.s": "南", "compass.sw": "西南", "compass.w": "西", "compass.nw": "西北",
  "handoff.title": "在单独窗口打开",
  "handoff.lede": "这是给你自己的链接。会在浏览器里打开同一个房间，这样 Discord 那边可以继续显示共享画面，地图放在另一块屏幕上。",
  "handoff.open": "在这台电脑的浏览器中打开", "handoff.or": "在其他设备上打开",
  "handoff.codeHint": "在那台设备上访问 {host}/j/ 并输入上面的代码。",
  "handoff.copy": "复制链接", "handoff.copied": "已复制",
  "handoff.copyFailed": "已选中上方内容 — 请按 Ctrl+C",
  "handoff.expiry": "此链接只能用一次，将在 {time} 后失效。",
  "handoff.warn": "不能转给别人（一打开就用掉了）。要叫人请用「邀请他人」。",
  "handoff.creating": "正在生成链接…", "handoff.failed": "无法生成链接",
  "invite.title": "邀请他人",
  "invite.lede": "把不在语音频道里的人叫进这张地图。对方打开链接、输入名字后就能放置标记。",
  "invite.copy": "复制链接", "invite.warn": "知道这个链接的人都能加入，请不要公开发布。",
  "invite.budget": "还可加入 {left} 人，{time} 后失效（已用 {used}/{max}）。",
  "invite.revoke": "立即作废此链接", "invite.revoked": "链接已作废。",
  "invite.creating": "正在生成链接…", "invite.failed": "无法生成链接",
  "invite.revokeFailed": "作废失败",
  "join.title": "加入地图",
  "join.lede": "你被邀请加入一张突袭地图。请设置一个显示名称，它会出现在你放置的标记上。",
  "join.name": "名称", "join.go": "加入", "join.joining": "正在加入…", "join.failed": "无法加入",
  "feedback.title": "发给作者", "feedback.request": "建议", "feedback.bug": "问题",
  "feedback.other": "其他", "feedback.requestHint": "希望能这样",
  "feedback.bugHint": "不对劲 / 不能用", "feedback.otherHint": "什么都行",
  "feedback.placeholder": "例如：希望不只箭头，还能画线 / Streets 的楼层切换不了",
  "feedback.note": "会一并发送你的 Discord 显示名称和 ID，以便需要时回复你。",
  "feedback.send": "发送", "feedback.sending": "发送中…", "feedback.sent": "已发送，谢谢！",
  "feedback.failed": "发送失败",
  "time.minutes": "约 {n} 分钟", "time.hoursMinutes": "约 {h} 小时 {m} 分钟",
  "error.roomFull": "这个房间已满",
  "error.tooManyWindows": "这个房间开得太多了，请关掉一个窗口。",
  "error.serverFull": "服务器已满", "error.session": "会话已失效，请重新打开。",
  "error.handoffSpent": "此链接无法使用。它是仅限本人、只能用一次的链接。要叫人请在地图上用「邀请他人」生成链接。",
  "error.inviteSpent": "此邀请链接已不能使用，请向房间里的人要一个新的。",
  "error.inviteNotOwner": "只有创建链接的人才能作废它",
  "error.noRoom": "未指定房间", "error.needName": "请输入名称",
  "error.tooShort": "请再写详细一点", "error.tooLong": "太长了",
  "error.badKind": "分类无效",
  "error.rateLimited": "发送太频繁，请等 10 分钟左右。",
  "error.busy": "当前比较拥挤，请稍后再试。",
  "error.sendFailed": "发送失败，请稍后再试。",
  "error.feedbackClosed": "目前暂停接收反馈",
  "error.sessionGone": "原会话已结束，请从活动中重新打开。",
  "landing.tagline1": "把塔科夫的地图",
  "landing.tagline2": "在 Discord 通话中一起看着讲解。",
  "landing.install": "添加到 Discord",
  "landing.installNote": "免费。从语音频道的火箭图标启动。",
  "landing.body": "通话中所有人看到同一张地图。点击放置标记，按住拖动还会带上方向箭头 —— 不只是「在哪里」，连「往哪边走」都能指出来。",
  "landing.point1": "在同一个通话里就会进入同一张地图，不用输入代码",
  "landing.point2": "全部 13 张地图。手绘与卫星图切换，还有楼层",
  "landing.point3": "放下的标记会留着，之后还能回看",
  "landing.point4": "不在通话里的人，也能用邀请链接加入",
  "landing.footNote": "完全不碰游戏。不读文件、不读内存，也不在游戏画面上画任何东西。每个标记都是人手动放的。",
  "landing.footCredit": "个人业余作品，免费运行。地图数据来自 {tarkovdev}（CC BY-NC-SA 4.0）。Escape from Tarkov 是 Battlestate Games Limited 的产品；本项目为非官方同人作品，与其无关。",
  "landing.updates": "更新记录", "landing.allUpdates": "全部更新",
  "boot.connecting": "正在连接 Discord…", "boot.failedTitle": "无法启动",
};
